import React from 'react';

type TextLinkOwnProps<C extends React.ElementType> = {
  as?: C;
  className?: string;
  children?: React.ReactNode;
};

type TextLinkProps<C extends React.ElementType> = TextLinkOwnProps<C> &
  Omit<React.ComponentPropsWithoutRef<C>, keyof TextLinkOwnProps<C>>;

const BASE =
  'inline bg-transparent p-0 border-0 border-b border-transparent text-we-accent-2 font-we-body font-semibold text-[13.5px] cursor-pointer hover:border-we-accent-2 transition-colors duration-[120ms]';

function TextLink<C extends React.ElementType = 'button'>({
  as,
  className = '',
  children,
  ...rest
}: TextLinkProps<C>) {
  const Component = as ?? 'button';
  return (
    <Component className={`${BASE} ${className}`.trim()} {...rest}>
      {children}
    </Component>
  );
}

export default TextLink;
